import { decodeDelimitedArray, encodeDelimitedArray } from "use-query-params"
import { ZodTypeAny, z } from "zod"
import {
  DateFilterSchema,
  IntFilterSchema,
  StringFilterSchema
} from "../graphql/filter-input"

// Configs that work with use-query-params.

// Uses a comma to delimit entries. e.g. ['a', 'b'] => qp?=a,b
export const CommaArrayParam = {
  encode: (array: string[] | null | undefined) =>
    encodeDelimitedArray(array, ","),

  decode: (
    arrayStr: string | (string | null)[] | null | undefined
  ): string[] | undefined => {
    // Decoding, ensuring we have a string[] or undefined return type.
    if (arrayStr) {
      return decodeDelimitedArray(arrayStr, ",")?.reduce((acc, str) => {
        if (typeof str === "string") {
          acc.push(str)
        }
        return acc
      }, [] as string[])
    }
  }
}

// Creates a filter param for a given Zod schema. The schemas are a union of
// object or array of objects, where the object is the filter input schema.
function createFilterParam<T extends ZodTypeAny>(FilterSchema: T) {
  type Filter = z.infer<typeof FilterSchema>

  return {
    encode: (array: Filter | Filter[] | null | undefined) =>
      encodeDelimitedArray(
        array
          ? ([] as Filter[]).concat(array).map((item) => JSON.stringify(item))
          : [],
        ","
      ),

    decode: (
      arrayStr: string | (string | null)[] | null | undefined
    ): Filter[] | undefined => {
      // Decoding, ensuring we have a string[] or undefined return type.
      if (arrayStr) {
        return decodeDelimitedArray(arrayStr, ",")?.reduce((acc, str) => {
          // We'll try/catch in case the JSON is malformed or doesn't pass the schema.
          // In that event, we just skip that entry.
          try {
            acc.push(FilterSchema.parse(JSON.parse(str || "{}")))
          } catch (error) {
            console.error("Error parsing filter:", error)
          }
          return acc
        }, [] as Filter[])
      }
    }
  }
}

export const StringFilterParam = createFilterParam(StringFilterSchema)
export const IntFilterParam = createFilterParam(IntFilterSchema)
export const DateFilterParam = createFilterParam(DateFilterSchema)
